import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { getAppointmentTypes } from '../../network/appointment';
import { queryKeys } from '../../services/react-query/queryKeys';
import Heading from '../../components/common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Flex,
  Popconfirm,
  Popover,
  Space,
  Table,
} from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { ModalAppAppointmentDuration } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteAppointmentTypes } from '../../network/AppointmentDuration';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
// import { getAppointmentTypes } from '../../network/AppointmentDuration';

const AppointmentDuration = ({ t }) => {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const client = useQueryClient();
  const { message } = App.useApp();
  const { data: appointmentTypes, isLoading } = useQuery({
    queryKey: [queryKeys.getAppointmentTypes],
    queryFn: () => getAppointmentTypes(),
    keepPreviousData: true,
  });
  const { mutate: onDeleteAppointmentTypes } = useMutation({
    mutationKey: ['deleteAppointmentTypes'],
    mutationFn: (id) => deleteAppointmentTypes(id),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getAppointmentTypes],
      });
    },
    onError: (error) => {
      message.error(error);
    },
  });
  return (
    <div>
      <Heading title={t.settings} subTitle={t.AppointmentDuration} path="" />
      <div>
        {/* <Flex align="center" justify="space-between" style={{ width: '100%' }}>
          <h3>{t.AppointmentDuration}</h3>
          <Button type="primary" onClick={() =>{
             setOpen(true)
             setEdit(false)
             setEditId("")
          }}>
            {t.AddAppointmentDuration}
          </Button>
        </Flex> */}
        <div style={{ margin: '30px 0 10px' }}>
          <DynamicTableAnt
            data={appointmentTypes?.message?.appointment_types}
            columns={[
              {
                title: t.Name,
                dataIndex: 'name',
                key: 'name',
                filteredValue: [searchText],
                onFilter: (value, record) => {
                  const name = String(record?.name).toLowerCase();
                  const searchValue = value.toLowerCase();
                  // console.log(record);
                  return name.includes(searchValue);
                },
              },
              {
                title: t.Duration,
                dataIndex: 'default_duration',
                key: 'default_duration',
              },
              {
                title: t.allowbookingfor,
                dataIndex: 'allowbookingfor',
                key: 'allowbookingfor',
                render: (text) => {
                  return <span>Practitioner</span>;
                },
              },
              {
                title: t.action,
                dataIndex: 'action',
                key: 'action',
                width: '20%',
                render: (text, record) => {
                  return (
                    <Space>
                      <Popover
                        placement="top"
                        title={t.edit}
                        onClick={() => {
                          setOpen(true);
                          setEdit(true);
                          setEditId(record?.name);
                        }}
                      >
                        <Button size="small" type="primary">
                          <MdModeEditOutline />
                        </Button>
                      </Popover>
                      <Popconfirm
                        title={t.DeletetheAppointmentDuration}
                        description={t.areYouSure}
                        okText={t.yes}
                        cancelText={t.no}
                        onConfirm={() => onDeleteAppointmentTypes(record?.name)}
                      >
                        <Button size="small" type="primary" danger>
                          <MdDelete />
                        </Button>
                      </Popconfirm>
                    </Space>
                  );
                },
              },
            ]}
            setSearchText={setSearchText}
            Placeholder={t.searchByName}
            rowKey="key"
            scroll={{ x: 'max-content' }}
            // className="table"
            loading={isLoading}
            buttonModal={
              <Button
                type="primary"
                onClick={() => {
                  setOpen(true);
                  setEdit(false);
                  setEditId('');
                }}
              >
                <PlusOutlined
                  style={{
                    fontSize: '10px',
                  }}
                />
                {t.AddAppointmentDuration}
              </Button>
            }
          />
        </div>
      </div>
      <ModalAppAppointmentDuration
        t={t}
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        setEditId={setEditId}
      />
    </div>
  );
};

export default AppointmentDuration;
